import { atom } from 'jotai'

import type { EdpTimeslotSelection } from './edp-timeslot-selection'

export const edpTimeslotSelectionAtom = atom<EdpTimeslotSelection | null>(null)
export const edpBookingModalOpenAtom = atom(false)
